import * as React from 'react';
import * as style from './style.css';
import { Button, Image, LinkButton, UIHeading4, UIText2 } from '@cian/ui-kit';
import { Features } from '../Features';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Card = _ref => {
  let {
    layout,
    onClick,
    onLinkClick
  } = _ref;
  const onCardClick = React.useCallback(() => {
    onClick(layout.layoutKey);
  }, [layout]);
  const isOfferLinkButton = React.useMemo(() => layout.offersCount === 1, [layout]);
  return /*#__PURE__*/_jsxs("div", {
    className: style['container'],
    children: [/*#__PURE__*/_jsxs("div", {
      className: style['image'],
      children: [/*#__PURE__*/_jsx(Image, {
        src: layout.image,
        alt: "\u041F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u043A\u0430 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u044B",
        objectFit: "contain"
      }), /*#__PURE__*/_jsx(Features, {
        features: layout.features
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: style['description'],
      children: [/*#__PURE__*/_jsxs(UIHeading4, {
        textAlign: "center",
        children: [layout.roomTypeDisplay, " ", layout.totalAreaDisplay]
      }), /*#__PURE__*/_jsx(UIText2, {
        textAlign: "center",
        children: layout.priceRangeDisplay
      })]
    }), isOfferLinkButton ? /*#__PURE__*/_jsx(LinkButton, {
      fullWidth: true,
      theme: "fill_secondary",
      href: layout.offersUrl,
      target: "_blank",
      onClick: onLinkClick,
      children: layout.offersCountDisplay
    }) : /*#__PURE__*/_jsx(Button, {
      fullWidth: true,
      theme: "fill_secondary",
      onClick: onCardClick,
      children: layout.offersCountDisplay
    })]
  });
};